import { createContext } from 'react';

export const PlatoClientContext = createContext(null);
